/* SEW Markaz - mobile bottom navigation

   Categories and Search open their own sheets instead of Dawn's header
   drawers. The header hides on scroll-down and Dawn positions its drawers from
   the header, so triggering them from the bottom of the page lands them
   off-screen. The sheets are self-contained and always open in view.

   Search opens full screen from the top with live product results, so the
   field and the results stay above the phone keyboard.

   Cart opens Dawn's cart drawer when the theme has one, otherwise follows the
   link to /cart. WhatsApp builds its message at tap time, so on a product page
   it carries the option the shopper actually picked. */

(function () {
  var lastFocus = null;

  function sheets() {
    return document.querySelectorAll('[data-sew-bsheet]');
  }

  function closeSheet(s) {
    if (!s || s.hidden) return;
    s.classList.remove('is-open');
    window.setTimeout(function () {
      if (!s.classList.contains('is-open')) s.hidden = true;
    }, 300);
  }

  function closeAll(restoreFocus) {
    var list = sheets();
    for (var i = 0; i < list.length; i++) closeSheet(list[i]);
    document.body.classList.remove('sew-bnav-lock');
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
    if (restoreFocus && lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  }

  function openSheet(name) {
    var s = document.querySelector('[data-sew-bsheet="' + name + '"]');
    if (!s) return false;
    var list = sheets();
    for (var i = 0; i < list.length; i++) {
      if (list[i] !== s) closeSheet(list[i]);
    }
    lastFocus = document.activeElement;
    s.hidden = false;
    document.body.classList.add('sew-bnav-lock');
    // Focus inside the tap itself - iOS only raises the keyboard for a focus
    // that happens during the user's gesture.
    var f = s.querySelector('[data-sew-autofocus]') || s.querySelector('.sew-bsheet__close');
    if (f) {
      try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
    }
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        s.classList.add('is-open');
      });
    });
    return true;
  }

  function selectedVariant() {
    var el = document.querySelector('variant-selects [data-selected-variant]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function buildWhatsApp(a) {
    var num = a.getAttribute('data-wa-number') || '';
    var title = a.getAttribute('data-wa-product');
    var text = a.getAttribute('data-wa-msg') || '';
    if (title) {
      var url = window.location.origin + window.location.pathname;
      var label = title;
      var v = selectedVariant();
      if (v) {
        if (v.title && v.title !== 'Default Title') label += ' (' + v.title.split(' / ').join(', ') + ')';
        if (v.id) url += '?variant=' + v.id;
      }
      text = (a.getAttribute('data-wa-msg-product') || '')
        .split('[product]').join(label)
        .split('[link]').join(url);
    }
    text = text.split('[br]').join('\n');
    a.href = 'https://wa.me/' + num + (text ? '?text=' + encodeURIComponent(text) : '');
  }

  /* ---------- live search ---------- */

  function money(v) {
    var n = Math.round(parseFloat(v) || 0);
    return 'Rs.' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function setupSearch() {
    var sheet = document.querySelector('[data-sew-bsheet="search"]');
    if (!sheet || sheet.dataset.sewReady === 'true') return;
    sheet.dataset.sewReady = 'true';

    var input = sheet.querySelector('input[type="search"]');
    var results = sheet.querySelector('[data-sew-bsearch-results]');
    var chips = sheet.querySelector('[data-sew-bsearch-chips]');
    if (!input || !results) return;

    var timer = null;
    var ctrl = null;
    var lastQ = '';

    function showChips() {
      results.hidden = true;
      results.innerHTML = '';
      if (chips) chips.hidden = false;
    }

    function seeAll(q) {
      var a = el('a', 'sew-bsearch__all', 'See all results for \u201c' + q + '\u201d');
      var base = (window.routes && window.routes.search_url) || '/search';
      a.href = base + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      return a;
    }

    function render(q, products) {
      results.innerHTML = '';
      if (!products.length) {
        results.appendChild(el('p', 'sew-bsearch__empty', 'No products found for \u201c' + q + '\u201d. Try a shorter word.'));
      } else {
        products.forEach(function (p) {
          var a = el('a', 'sew-bsearch__item');
          a.href = p.url;
          var src = (p.featured_image && p.featured_image.url) || p.image || '';
          if (src) {
            var img = el('img', 'sew-bsearch__img');
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=140';
            img.alt = '';
            img.loading = 'lazy';
            img.width = 56;
            img.height = 56;
            a.appendChild(img);
          } else {
            a.appendChild(el('span', 'sew-bsearch__img'));
          }
          var info = el('span', 'sew-bsearch__info');
          info.appendChild(el('span', 'sew-bsearch__title', p.title));
          var price = el('span', 'sew-bsearch__price');
          var min = parseFloat(p.price_min || p.price) || 0;
          var max = parseFloat(p.price_max || p.price) || 0;
          price.textContent = (max > min ? 'From ' : '') + money(min);
          var cmp = parseFloat(p.compare_at_price_min || p.compare_at_price_max) || 0;
          if (cmp > min) price.appendChild(el('s', null, money(cmp)));
          info.appendChild(price);
          if (p.available === false) info.appendChild(el('span', 'sew-bsearch__oos', 'Out of stock'));
          a.appendChild(info);
          results.appendChild(a);
        });
      }
      results.appendChild(seeAll(q));
      results.hidden = false;
      if (chips) chips.hidden = true;
    }

    function search(q) {
      if (q === lastQ) return;
      lastQ = q;
      if (ctrl && typeof ctrl.abort === 'function') ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
      var url = base + '.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=8' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,tag';
      fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== lastQ) return;
          var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          render(q, list);
        })
        .catch(function () { /* aborted or offline - leave the last results up */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      window.clearTimeout(timer);
      if (q.length < 2) {
        lastQ = '';
        if (ctrl && typeof ctrl.abort === 'function') ctrl.abort();
        showChips();
        return;
      }
      timer = window.setTimeout(function () { search(q); }, 220);
    });

    // Scrolling the results is the signal the shopper is done typing -
    // drop the keyboard so they can see the whole list.
    var body = sheet.querySelector('.sew-bsheet__body');
    if (body) {
      body.addEventListener('touchmove', function () {
        if (document.activeElement === input) input.blur();
      }, { passive: true });
    }
  }

  function init() {
    setupSearch();

    var nav = document.querySelector('[data-sew-bnav]');
    if (!nav || nav.dataset.sewReady === 'true') return;
    nav.dataset.sewReady = 'true';
    document.body.classList.add('sew-has-bnav');

    nav.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-sew-bnav-open]');
      if (opener) {
        if (openSheet(opener.getAttribute('data-sew-bnav-open'))) e.preventDefault();
        return;
      }
      var cartLink = e.target.closest('[data-sew-bnav-cart]');
      if (cartLink) {
        var drawer = document.querySelector('cart-drawer');
        var onCartPage = /\/cart\/?$/.test(window.location.pathname);
        if (drawer && typeof drawer.open === 'function' && !onCartPage) {
          e.preventDefault();
          closeAll(false);
          drawer.open(cartLink);
        }
        return;
      }
      var wa = e.target.closest('[data-sew-bnav-wa]');
      if (wa) buildWhatsApp(wa);
    });

    // Cart count - Dawn announces every cart change on its pub/sub bus and also
    // re-renders the header bubble; either one triggers a single /cart.js read.
    var countEl = nav.querySelector('[data-sew-bnav-count]');
    var timer = null;
    function setCount(n) {
      if (!countEl) return;
      n = parseInt(n, 10) || 0;
      countEl.textContent = n > 99 ? '99+' : String(n);
      countEl.hidden = n === 0;
    }
    function refreshCount() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        var base = (window.routes && window.routes.cart_url) || '/cart';
        fetch(base + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { setCount(c.item_count); })
          .catch(function () { /* keep the last known count */ });
      }, 200);
    }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
      }
    } catch (e) { /* older theme without pub/sub */ }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && 'MutationObserver' in window) {
      new MutationObserver(refreshCount).observe(bubble, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCount();
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sew-bsheet-close]')) {
      e.preventDefault();
      closeAll(true);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('sew-bnav-lock')) closeAll(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
